export class SocialNetworkReference {
  public hubId: number;
  public socialNetworkId: number;
}
